import React from "react";
import { formatGs, LOCATION_NAMES, formatDate } from "@/lib/format";
import { History, Users } from "lucide-react";

const diffCls = (d) => (d === 0 ? "text-emerald-500" : d < 0 ? "text-red-500" : "text-amber-500");

export const CashHistory = ({ data }) => {
  const sessions = data?.sessions || [];
  const byUser = data?.by_user || [];
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
      <div className="card-surface p-5">
        <h3 className="font-head font-bold mb-4 flex items-center gap-2"><Users className="w-4 h-4 text-primary" /> Diferencias por usuario</h3>
        <div className="space-y-2" data-testid="cash-by-user">
          {byUser.map((u) => (
            <div key={u.user + u.location} className="p-3 rounded-lg bg-secondary">
              <div className="flex justify-between text-sm"><span className="font-semibold">{u.user}</span><span className={`font-data font-bold ${diffCls(u.difference)}`}>{formatGs(u.difference)}</span></div>
              <p className="text-[11px] text-muted-foreground mt-0.5">{LOCATION_NAMES[u.location]} · {u.sessions} cierres · faltante {formatGs(u.faltantes)} · sobrante {formatGs(u.sobrantes)}</p>
            </div>
          ))}
          {byUser.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">Sin arqueos en el período</p>}
        </div>
      </div>
      <div className="lg:col-span-2 card-surface p-5 overflow-hidden">
        <h3 className="font-head font-bold mb-4 flex items-center gap-2"><History className="w-4 h-4 text-primary" /> Historial de arqueos</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="cash-history-table">
            <thead><tr className="text-left text-[10px] tracking-widest text-muted-foreground border-b border-border">
              <th className="py-2 pr-3">CIERRE</th><th className="pr-3">LOCAL</th><th className="pr-3">USUARIO</th><th className="pr-3 text-right">INICIAL</th><th className="pr-3 text-right">ESPERADO</th><th className="pr-3 text-right">CONTADO</th><th className="text-right">DIFERENCIA</th>
            </tr></thead>
            <tbody>
              {sessions.map((s) => (
                <tr key={s.id} className="border-b border-border/50" data-testid={`cash-row-${s.id}`}>
                  <td className="py-2 pr-3 whitespace-nowrap text-xs">{formatDate(s.closed_at)}</td>
                  <td className="pr-3">{LOCATION_NAMES[s.location]}</td>
                  <td className="pr-3 whitespace-nowrap">{s.opened_by}{s.handover_to ? ` → ${s.handover_to} (traspaso)` : s.closed_by && s.closed_by !== s.opened_by ? ` → ${s.closed_by}` : ""}</td>
                  <td className="pr-3 text-right font-data">{formatGs(s.opening_amount)}</td>
                  <td className="pr-3 text-right font-data">{formatGs(s.expected_cash)}</td>
                  <td className="pr-3 text-right font-data">{formatGs(s.counted_amount)}</td>
                  <td className={`text-right font-data font-bold ${diffCls(s.difference)}`}>{formatGs(s.difference)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {sessions.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">Sin cajas cerradas</p>}
        </div>
      </div>
    </div>
  );
};
